
import Schema from 'AppReact/schema';
import { option } from './types';

export default {
  options: Schema(option, 'array', { defaultValue: [] }),
  selectedOption: Schema('string', 'primitive'),
  allowEdit: Schema('boolean', 'primitive', { defaultValue: true })
}